<template>
  <div class="flex justify-center pt-8 min-h-screen h-full text-yellow-300 bg-black p-3">
    <div class="container mx-auto max-w-3xl">
      <Header />
      <div v-if="tipWeergeven" class="absolute z-50 top-10 left-0 right-0">
        <div class="bg-primary mx-auto w-1/2 p-3">
          <p class="text-black uppercase text-center">
            <span class="font-bold text-black">Tip!</span>
            Vul alles in
          </p>
        </div>
      </div>
      <div v-if="verplichtMeldingWeergeven" class="absolute z-50 top-10 left-0 right-0">
        <div class="bg-primary mx-auto w-1/2 p-3">
          <p class="text-black uppercase text-center">
            <span class="font-bold text-black">Let op!</span>
            Contactpersoon en Email zijn verplicht
          </p>
        </div>
      </div>

      <router-view v-slot="{ Component }" :pages="pages" :totalPrice="totalPrice" :selectedValues="selectedValues"
        @add="add" @remove="remove" @setValue="setValue" @setValueAndSend="setValueAndSend"
        @InlineButtonClickHandler="InlineButtonClickHandler">
        <transition name="fade" mode="out-in">
          <component :is="Component" :title="Title"></component>
        </transition>
      </router-view>
      <div v-if="debugEnabled" class="mt-6 border border-primary p-4">
        <h3 class="font-bold mb-2">Debug informatie</h3>
        <pre class="text-xs whitespace-pre-wrap">{{ debugOutput }}</pre>
      </div>
      <Footer />
    </div>
  </div>
</template>

<script>
import Header from "./components/Header";
import Footer from "./components/Footer";
import Data from './data/data.json'


export default {
  components: {
    Header,
    Footer,

  },
  data() {
    return {
      message: '',
      selectedValues: [],
      totalPrice: 2.0,
      step: 0,
      pages: Data,
      returnData: '',
      tipWeergeven: false,
      verplichtMeldingWeergeven: false
    };
  },
  computed: {
    debugEnabled() {
      return String(process.env.VUE_APP_DEBUG).toLowerCase() === 'true';
    },
    debugOutput() {
      return JSON.stringify(
        {
          selectedValues: this.selectedValues,
          totalPrice: this.totalPrice,
          pages: this.pages,
        },
        null,
        2,
      );
    },
  },
  methods: {
    InlineButtonClickHandler(current) {


      //update "winkelwagen"
      var el = this.selectedValues.filter(function (el) {
        return el.key === current;
      });

      if (el.length) {
        this.tipWeergeven = false;
      }
      else {
        this.tipWeergeven = true;
      }


    },
    add(ammount = 1) {
      this.totalPrice = this.totalPrice + ammount;
      console.log(this.totalPrice);
    },
    remove(ammount = 1) {
      this.totalPrice = this.totalPrice - ammount;
      console.log(this.totalPrice);
    },
    setValueAndSend(key, value, title, required = false) {



      if(!this.setValue(key, value, title, required)){
        return false;
      }

      //Doorgeven aan Parkpoint API
      fetch(process.env.VUE_APP_API_URL + 'api/slagboomconfigurator', {
        method: 'POST',
        body: JSON.stringify({
          key: process.env.VUE_APP_API_CODE,
          input: this.selectedValues,
        }),
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
        },
      })
        .then((response) => response.json())
        .then((json) => {
          this.returnData = json.message;
          if (this.returnData == 'send') {
            console.log('works')
            this.$router.push({ path: '/klaar' });
          }
        });
      //console.log('works')

      this.verplichtMeldingWeergeven = false;
      this.$router.push({ path: '/klaar' });


    },
    setValue(key, value, title, required = false) {
      if (required) {
       // alert('work');
        if (title === undefined || title.length < 1) {
          this.verplichtMeldingWeergeven = true;
          return false;
        }
      }
   
    
    

      var newVal = {
        key: key,
        value: value,
        title: title
      };
      //update "winkelwagen"
      var el = this.selectedValues.filter(function (el) {
        return el.key === newVal.key;
      });

      if (el.length) {
        el[0].value = newVal.value;
        el[0].title = newVal.title;

      } else {
        this.selectedValues.push(newVal);
      }

      //update "formulier data"
      var formdata = this.pages.filter(function (formdata) {
        return formdata.slug === key
      });

      if (formdata.length) {
        var i, n = formdata[0].options.length;
        var options = formdata[0].options;
        for (i = 0; i < n; ++i) {
          if (newVal.title == options[i]['title']) {
            options[i]['selected'] = true;
          } else {
            options[i]['selected'] = false;
          }
        }

        console.log(formdata[0].options.length);
      } else {
        console.log('Form niet gevonden');
      }
      console.log(this.pages);
      return true;

    },
  },

  name: "App",
};

</script>

<style>
#app {}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.35s ease;
}

.fade-enter-from,
.fade-leave-active {
  opacity: 0;
}
</style>
